"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  fill: "#E60023",
  d: "M12.012 3.749a8.242 8.242 0 0 0-3.005 15.915c-.072-.652-.137-1.652.028-2.364.151-.644.967-4.096.967-4.096s-.247-.495-.247-1.225c0-1.143.665-2.001 1.491-2.001.704 0 1.044.529 1.044 1.161 0 .707-.449 1.765-.682 2.745-.196.82.412 1.489 1.221 1.489 1.463 0 2.59-1.543 2.59-3.772 0-1.967-1.419-3.347-3.443-3.347-2.345 0-3.719 1.761-3.719 3.574 0 .71.271 1.473.611 1.885a.25.25 0 0 1 .058.237c-.062.258-.202.825-.229.937-.037.155-.118.186-.276.113-1.028-.474-1.673-1.979-1.673-3.195 0-2.596 1.889-4.986 5.445-4.986 2.859 0 5.082 2.04 5.082 4.76 0 2.843-1.792 5.13-4.286 5.13-.835 0-1.619-.433-1.896-.948l-.515 1.958c-.185.718-.69 1.617-1.03 2.163a8.3 8.3 0 0 0 2.441.368c4.542 0 8.24-3.689 8.24-8.241s-3.698-8.241-8.24-8.241z"
}), 'Pinterest');
//# sourceMappingURL=index.js.map